export default "__VITE_ASSET__C35_44ns__"